module.exports = __webpack_public_path__ + "static/media/CloseUp2.dfea9053.jpeg";